import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    canCheckoutWithCart,
    getCurrentCartState,
    isCartCheckoutDisabled,
    isCartEmpty,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import CartTotalDisplay from "@insite/content-library/Components/CartTotalDisplay";
import ProductDescription from "@insite/content-library/Components/ProductDescription";
import ProductImage from "@insite/content-library/Components/ProductImage";
import Button from "@insite/mobius/Button";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface MiniCartStyles {
    container: InjectableCss;
    productInfo: InjectableCss;
    cartInfo: InjectableCss;
    actions: InjectableCss;
    topBar: InjectableCss;
    productButton: InjectableCss;
}
export const miniCartStyles: MiniCartStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    productInfo: {
        css: css`
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            text-align: right;
        `,
    },
    cartInfo: {
        css: css`
            display: flex;
            flex-direction: row;
            margin-top: 10px;
            margin-bottom: 10px;
        `,
    },
    productButton: {
        css: css`
            text-align: right;
        `,
    },
    actions: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        `,
    },
    topBar: {
        css: css`
            display: flex;
            flex: 0 0 100%;
            margin-bottom: 10px;
        `,
    },
};

interface OwnProps {
    addedProduct: any;
}

const mapStateToProps = (state: ApplicationState) => {
    const cart = getCurrentCartState(state).value;
    return {
        cart,
        cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
        canCheckoutWithCart: canCheckoutWithCart(cart),
        isCartCheckoutDisabled: !cart || isCartCheckoutDisabled(cart),
        isCartEmpty: isCartEmpty(cart),
        checkoutShippingPageUrl: getPageLinkByPageType(state, "CheckoutShippingPage")?.url,
    };
};

const mapDispatchToProps = {
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const MiniCart: FC<Props> = ({
    cart,
    addedProduct,
    cartUrl,
    checkoutShippingPageUrl,
    canCheckoutWithCart,
    isCartCheckoutDisabled,
    isCartEmpty,
}) => {
    const checkoutHandler = () => {
        // WAS-352 | Redirecting to Checkout Page, as the data is handelled there directly.
        window.location.href = checkoutShippingPageUrl!; // WAS-122 workaround for possible base bug in SpireRouter.tsx regarding history context
    };
    const cartHandler = () => {
        // history.push(checkoutShippingPageUrl!);
        window.location.href = cartUrl!; // WAS-122 workaround for possible base bug in SpireRouter.tsx regarding history context
    };
    return (
        <StyledWrapper {...miniCartStyles.container}>
            <StyledWrapper {...miniCartStyles.topBar}>
                <Typography variant="p" weight="bold" data-test-selector="cdtMiniCart">
                    Item(s) successfully added to cart
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...miniCartStyles.productInfo}>
                <ProductImage product={addedProduct}></ProductImage>
                <ProductDescription product={addedProduct}></ProductDescription>
            </StyledWrapper>
            <StyledWrapper {...miniCartStyles.cartInfo}>
                <CartTotalDisplay cart={cart} isCartEmpty={isCartEmpty} showTaxAndShipping={false} />
            </StyledWrapper>
            <StyledWrapper {...miniCartStyles.actions}>
                <Button onClick={cartHandler}>{translate("View Cart")}</Button>
                {canCheckoutWithCart && (
                    <Button onClick={checkoutHandler} disabled={isCartCheckoutDisabled}>
                        {translate("Checkout")}
                    </Button>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniCart);